<template>
  <v-flex xs12 class="px-2 pt-0">
    <!-- <v-card color="grey lighten-5" class="rounded-card" style="width:100%">  -->
    <div class>
      <div class="flex-container-space-between" style="align-items:center">
        <v-form ref="tripForm" class="w100" @submit.prevent="submitTrip()">
          <div class="flex-container-space-between vertical-center-container">
            <!-- <layout-no-padding> -->
            <transition-group name="field-list" tag="layout-no-padding">
              <v-flex xs12 key="1" v-if="useNightRate" class="field-list-item pt-0">
                <div
                  :class="`${primaryNeutral}--text lighten-1 caption font-italic`"
                >* Using night rate for this trip</div>
              </v-flex>
              <v-flex xs12 key="1" v-if="useAltRate" class="field-list-item pt-0">
                <div
                  :class="`${primaryNeutral}--text lighten-1 caption font-italic`"
                >* Using the alternate rate for this trip</div>
              </v-flex>
              <v-flex xs12 key="1" v-if="useOverrideCost" class="field-list-item pt-0">
                <div
                  :class="`${primaryNeutral}--text lighten-1 caption font-italic`"
                >* Using the sub-contractor cost override for this trip</div>
              </v-flex>
              <!-- <v-flex xl2 lg2 md3 sm6 xs12 key="3" class="field-list-item">
                <v-autocomplete
                  label="* Tip"
                  color="indigo"
                  prepend-icon="delete_sweep"
                  clearable
                  :items="filteredTips"
                  item-text="name"
                  item-value="id"
                  v-model="tipId"
                  :hint="tippingDocketRequiredHint"
                  :rules="tipRules"
                ></v-autocomplete>
              </v-flex>-->

              <v-flex xl2 lg2 md3 sm6 xs12 key="2" class="field-list-item">
                <v-autocomplete
                  label="* Tip"
                  color="indigo"
                  prepend-icon="delete_sweep"
                  clearable
                  :items="filteredTips"
                  @change="spoilId = null"
                  item-text="name"
                  item-value="id"
                  v-model="tipId"
                  :hint="tippingDocketRequiredHint"
                  :rules="tipRules"
                ></v-autocomplete>
              </v-flex>

              <v-flex xl2 lg2 md3 sm6 xs12 key="3" class="field-list-item">
                <v-autocomplete
                  @keyup.f2="action"
                  ref="spoilField"
                  label="* Spoil"
                  color="indigo"
                  prepend-icon="loop"
                  clearable
                  :items="filteredSpoils"
                  item-text="name"
                  item-value="id"
                  v-model="spoilId"
                  :rules="spoilRules"
                ></v-autocomplete>
              </v-flex>

              <template v-if="showWeight">
                <v-flex lg2 md2 sm4 xs12 key="4" class="field-list-item">
                  <v-text-field
                    color="indigo"
                    label="Weighbridge/Tip Weight"
                    prepend-icon="shopping_basket"
                    v-model.number="siteWeight"
                    :rules="siteWeightRules"
                    :disabled="weightDisabled"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md2 sm4 xs12 key="5" class="field-list-item">
                  <v-text-field
                    color="indigo"
                    label="LoadRite/Site Weight"
                    prepend-icon="shopping_basket"
                    v-model.number="tipWeight"
                    :rules="tipWeightRules"
                    :disabled="weightDisabled"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md2 sm4 xs12 key="6" class="field-list-item">
                  <v-text-field
                    color="indigo"
                    label="Scale/Truck Weight"
                    prepend-icon="shopping_basket"
                    v-model.number="scaleWeight"
                    :rules="scaleWeightRules"
                    :disabled="weightDisabled"
                  ></v-text-field>
                </v-flex>
              </template>

              <!-- QUANTITY DATA ENTRY -->
              <v-flex xl1 lg1 md2 sm4 xs6 key="7" class="field-list-item" v-if="showQty">
                <v-text-field
                  color="indigo"
                  label="Quantity"
                  prepend-icon="chevron_right"
                  v-model.number="qty"
                  :rules="qtyRules"
                ></v-text-field>
                <!-- Using per {{displayRate.costUnit}} rate -->
              </v-flex>

              <template v-if="showHours">
                <!-- <template v-if="!hasRate || displayRate.costUnit == 'HOUR' || displayRate.sellUnit == 'HOUR'">   -->
                <!-- <template v-if="hasRate && (!displayRate.costUnit == 'EA' && !displayRate.costUnit == 'DAY' && !displayRate.sellUnit == 'EA' && !displayRate.sellUnit == 'DAY' )">   -->
                <v-flex lg1 md2 xs4 key="8" class="field-list-item">
                  <time-picker-wrapper v-model="start" label="Start Time"></time-picker-wrapper>
                </v-flex>
                <v-flex lg1 md2 xs4 key="9" class="field-list-item">
                  <time-picker-wrapper v-model="end" label="End Time"></time-picker-wrapper>
                </v-flex>
              </template>
              <template class="flex-container-space-between">
                <template v-if="showHours">
                  <v-flex xs12 sm2 key="11" class="field-list-item">
                    <v-text-field
                      color="indigo"
                      label="Breaks"
                      prepend-icon="alarm_off"
                      v-model.number="breaks"
                      :rules="breaksRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2 key="12" class="field-list-item">
                    <v-text-field
                      color="indigo"
                      label="Travel"
                      prepend-icon="add_alarm"
                      v-model.number="travel"
                      :rules="travelRules"
                    ></v-text-field>
                  </v-flex>
                </template>
                <!-- W/B DOCKET # -->
                <v-flex xs12 sm2 key="14">
                  <v-text-field
                    color="indigo"
                    label="W/B Docket #"
                    prepend-icon="note"
                    v-model="wbDocketNumber"
                    :rules="wbDocketNumberRules"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm8 xs12 key="10" class="field-list-item">
                  <v-text-field
                    @keyup.f2="action"
                    color="indigo"
                    label="Trip Notes"
                    prepend-icon="note"
                    v-model="notes"
                    :rules="noteRules"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  xs12
                  class="text-xs-right pb-4 pr-0 field-list-item"
                  style="align-self: flex-end"
                  key="13"
                  v-if="!!hasRate"
                >
                  <!-- <v-flex lg6 md2 sm4 xs4 class="text-xs-right pb-4 pr-0 field-list-item" style="align-self: flex-end" key="11">  -->
                  <v-btn
                    flat
                    type="submit"
                    :color="$store.state.global.pages.docket.color"
                    v-if="!!displayRate.id"
                  >Add</v-btn>
                </v-flex>
              </template>
            </transition-group>
            <!-- </layout-no-padding> -->
          </div>
        </v-form>
      </div>
    </div>
    <!-- </v-card> -->
  </v-flex>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import TipSpoilService from '@/services/requests/tipSpoilService'
import TripValidation from '@/services/validation/tripValidation'
import TimePickerWrapper from '@/components/ui/timePickerWrapper'
import FilterTipSpoils from '@/services/mixins/filterTipSpoils'
//import ProjectTipService from '@/services/requests/projectTipService'
import TripShared from './mixins/tripShared'
import TripConditionalFields from './mixins/tripConditionalFields'
export default {
  components: {
    TimePickerWrapper
  },
  mixins: [TripValidation, FilterTipSpoils, TripShared, TripConditionalFields],

  data() {
    return {
      prefix: '',
      weightDisabled: false
    }
  },
  methods: {
    action(event) {
      this.commitDocket = true
    },

    submitTrip() {
      if (!this.$refs.tripForm.validate()) {
        this.snack({ text: 'Please correct form errors.', color: 'red' })
        return
      } else if (!this.hasRate) {
        this.snack({
          text: 'Cannot submit trip with no pricing.',
          color: 'red'
        })
        return
      } else {
        this.addTrip()
      }
    },
    addTrip() {
      var trip = {
        start: this.start,
        end: this.end,
        spoilId: this.spoilId,
        tipId: this.tipId,
        spoil: this.spoilObj,
        tip: this.tipObj,
        siteWeight: Number(this.siteWeight),
        qty: Number(this.qty),
        breaks: Number(this.breaks),
        travel: Number(this.travel),
        tipWeight: Number(this.tipWeight),
        scaleWeight: Number(this.scaleWeight),
        wbDocketNumber: this.wbDocketNumber,
        notes: this.notes,
        useNightRate: this.useNightRate,
        useAltRate: this.useAltRate,
        useOverrideCost: this.useOverrideCost,
        rateType: this.rateType
      }

      this.$store.commit('dockets/addToArrayStatePush', {
        prop: 'trips',
        value: trip
      })
      if (!!this.showHours) {
        this.docketRateId = this.displayRate.id
      }
      this.resetTrip()
    },

    resetTrip() {
      this.start = ''
      this.end = ''
      this.siteWeight = 0
      this.tipWeight = 0
      this.scaleWeight = 0
      this.qty = 0
      this.wbDocketNumber = ''
      this.notes = ''
      this.breaks = 0
      this.travel = 0
      this.useOverrideCost = false
      //this.tip = "";
      //this.useNightRate = false;
      //this.useAltRate = false;
      this.$refs.tripForm.resetValidation()
      this.$refs.spoilField.focus()
    },
    // filterListByTipSpoils(array, arrayIdProp, otherIdProp, otherSelectedValue) {
    //   return array.filter(item => {
    //     return !!this.tipSpoils.filter(combination => {
    //       return (
    //         combination[arrayIdProp] == item.id &&
    //         combination[otherIdProp] == otherSelectedValue
    //       );
    //     }).length;
    //   });
    // },
    // async filterTipListByProject(array, arrayIdProp, otherIdProp, otherSelectedValue, projectId) {
    //   return array.filter(item => {

    //     return !!this.tipProjects.filter(combination => {
    //       //console.log('Check tips',combination.tipId, item.id, combination.projectId, projectId);

    //         return combination.tipId == item.id && combination.projectId == projectId
    //     }).length;
    //   });
    // },

    initAllocation(val) {
      if (!!Object.keys(val).length) {
        this.spoilId = val.spoilId
        this.tipId = val.tipId
      }
    }
  },
  asyncComputed: {
    // tipSpoils: {
    //   default: [],
    //   get() {
    //     if (!this.tipId && !this.spoilId) {
    //       return [];
    //     }
    //     var primaryId;
    //     var type;
    //     if (!!this.tipId) {
    //       type = "tip";
    //       primaryId = this.tipId;
    //     } else {
    //       type = "spoil";
    //       primaryId = this.spoilId;
    //     }
    //     return TipSpoilService.getTipSpoilsById(primaryId, type)
    //       .then(result => {
    //         //console.log(result.data.result)
    //         return result.data.result;
    //       })
    //       .catch(err => {
    //         this.snackError();
    //         console.log(err);
    //         return [];
    //       });
    //   }
    // },
    // tipProjects: {
    //   default: [],
    //   get() {
    //     if (!this.siteObj) {
    //       return [];
    //     }
    //     return ProjectTipService.getProjectTipsById(this.siteObj.projectId, 'project')
    //       .then(result => {
    //         //console.log(result.data.result)
    //         return result.data.result;
    //       })
    //       .catch(err => {
    //         this.snackError();
    //         console.log(err);
    //         return [];
    //       });
    //   }
    // },
    // async filteredTips() {
    //   if (!!this.siteObj) {
    //     var firstFilteredList = await this.filterTipListByProject(
    //       this.tips,
    //       "tipId",
    //       "spoilId",
    //       this.spoilId,
    //       this.siteObj.projectId
    //     );
    //     if(!!this.spoilId) {
    //       return this.filterListByTipSpoils(
    //         firstFilteredList,
    //         "tipId",
    //         "spoilId",
    //         this.spoilId,
    //       );
    //     } else {
    //       return firstFilteredList
    //     }
    //     // return this.filterTipListByProject(
    //     //   this.tips,
    //     //   "tipId",
    //     //   "spoilId",
    //     //   this.spoilId,
    //     //   this.siteObj.projectId
    //     // );
    //   } else {
    //     return this.tips;
    //   }
    // },
  },
  computed: {
    //GET SELECTED ALLOCATION FROM STORE
    selectedAllocation: Store.getSet({
      store: 'dockets',
      prop: 'selectedAllocation'
    }),
    //FROM VALUES
    start: Store.getSet({ store: 'trips', prop: 'start' }),
    end: Store.getSet({ store: 'trips', prop: 'end' }),
    tipId: Store.getSet({ store: 'trips', prop: 'tip' }),
    spoilId: Store.getSet({ store: 'trips', prop: 'spoil' }),
    siteWeight: Store.getSet({ store: 'trips', prop: 'siteWeight' }),
    scaleWeight: Store.getSet({ store: 'trips', prop: 'scaleWeight' }),
    tipWeight: Store.getSet({ store: 'trips', prop: 'tipWeight' }),
    qty: Store.getSet({ store: 'trips', prop: 'qty' }),
    breaks: Store.getSet({ store: 'trips', prop: 'breaks' }),
    travel: Store.getSet({ store: 'trips', prop: 'travel' }),
    wbDocketNumber: Store.getSet({ store: 'trips', prop: 'wbDocketNumber' }),
    notes: Store.getSet({ store: 'trips', prop: 'notes' }),
    tripRate: Store.getSet({ store: 'trips', prop: 'tripRate' }),
    displayRate: Store.getSet({ store: 'trips', prop: 'displayRate' }),
    useNightRate: Store.getSet({ store: 'trips', prop: 'useNightRate' }),
    useAltRate: Store.getSet({ store: 'trips', prop: 'useAltRate' }),
    useOverrideCost: Store.getSet({ store: 'trips', prop: 'useOverrideCost' }),
    docketRateId: Store.getSet({ store: 'dockets', prop: 'docketRateId' }),
    date: Store.getSet({ store: 'dockets', prop: 'date' }),
    commitDocket: Store.getSet({ store: 'dockets', prop: 'commitDocket' }),

    rateType() {
      if (this.useNightRate) {
        return 'Night'
      } else if (this.useAltRate && !!this.displayRate) {
        return `Alt Rate / ${this.displayRate.costUnitAlt}`
      } else if (this.useOverrideCost) {
        return 'Override'
      } else {
        return `Standard`
      }
    },

    hasRate() {
      //return !!Object.keys(this.tripRate).length
      //return !!this.displayRate;
      if (!this.displayRate) return false
      if (!!this.displayRate.id) {
        return true
      } else {
        return false
      }
    },

    // filteredSpoils() {
    //   if (!!this.tipId) {
    //     return this.filterListByTipSpoils(
    //       this.spoils,
    //       "spoilId",
    //       "tipId",
    //       this.tipId
    //     );
    //   } else {
    //     return this.spoils;
    //   }
    // },
    tips: Store.getSet({ store: 'tips', prop: 'tips' }),
    spoils: Store.getSet({ store: 'spoils', prop: 'spoils' }),
    siteObj: Store.getSet({ store: 'dockets', prop: 'siteObj' }),
    projectId() {
      return !!this.siteObj ? this.siteObj.projectId : null
    }
  },
  watch: {
    //WATCH SELECTED ALLOCATION TO SET PRE SET DATA VALUES WHEN SELECTED
    selectedAllocation(val) {
      this.initAllocation(val)
    },
    displayRate(val) {
      if (!!val && val.useTonnage) {
        this.siteWeight = val.vehicleType.tonnage
        this.scaleWeight = val.vehicleType.tonnage
        this.tipWeight = val.vehicleType.tonnage
        this.weightDisabled = true
      } else {
        this.weightDisabled = false
      }
    }
  },
  mounted() {
    this.initAllocation(this.selectedAllocation)
  }
}
</script>

<style scoped>
</style>
